import { ICustomSize, ICustomSizeValues } from '@vfit/shared/models';

const DEFAULT_SIZE: ICustomSize = {
  default: {
    width: 405,
  },
  mobile: {
    width: 332,
  },
  tablet: {
    width: 329,
  },
};

/**
 * Return the size of slide
 * @param slideIndex
 * @param isMobile
 * @param isTablet
 */
const getSlideSize = (
  slideIndex: number,
  isMobile: boolean,
  isTablet?: boolean
): ICustomSizeValues => {
  if (isTablet) return DEFAULT_SIZE.tablet || DEFAULT_SIZE.mobile;
  return isMobile ? DEFAULT_SIZE.mobile : DEFAULT_SIZE.default;
};

export { getSlideSize, DEFAULT_SIZE };
